module.exports = __webpack_public_path__ + "de.b55ae913.svg";